/** @jsxImportSource @emotion/react */
import React from 'react';
import { DatePicker, Form, Select, Typography } from 'antd';
import commonStyles from '../../../../../styles/commonStyles';
import { formStyles } from '../constants';
import { originTypeOptions } from '../constants';

/** Origin type (propagation method) and origin date fields */
const OriginSection: React.FC = () => (
  <>
    <Typography.Title level={5} css={formStyles.sectionTitle}>
      Происхождение
    </Typography.Title>

    <Form.Item
      label="Способ размножения"
      name="originType"
      tooltip="Как было получено растение: из семян, черенка, саженца и т.д."
    >
      <Select allowClear placeholder="Не указан" options={[...originTypeOptions]} />
    </Form.Item>

    <Form.Item
      label="Дата происхождения"
      name="originDate"
      tooltip="Реальная дата посева семян, укоренения черенка или приобретения саженца. Используется для расчёта возраста растения."
    >
      <DatePicker format="YYYY-MM-DD" css={commonStyles.fullWidth} allowClear />
    </Form.Item>
  </>
);

export default OriginSection;
